import React from 'react';

import AI from './AI';
import TwoColumn from '../../components/TwoColumn';

export default function FlipAI() {
  return (
    <TwoColumn>
      <TwoColumn.Left>
        <AI />
      </TwoColumn.Left>
      <TwoColumn.Right />
    </TwoColumn>
  );
}
